import { render, staticRenderFns } from "./FlangeAdapters.vue?vue&type=template&id=02ca43fb&scoped=true&lang=pug"
import script from "./FlangeAdapters.vue?vue&type=script&lang=js"
export * from "./FlangeAdapters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ca43fb",
  null
  
)

export default component.exports